const SORTORDER = {
  ASC: 'ascending',
  DESC: 'descending'
}

const Headings = [
    {
      id: "apiURL",
      label: "API URL",
      sortOrder: SORTORDER.ASC
    },
    { 
      id: "totalRequests",    
      label: "Requests",
      sortOrder: SORTORDER.DESC 
    },
    { 
      id: "total2XXSuccess",  
      label: "2XX",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "total400Errors",   
      label: "400",
      sortOrder: SORTORDER.ASC 
    },
    // { 
    //   id: "total401Errors",   
    //   label: "401",
    //   sortOrder: SORTORDER.ASC 
    // },
    { 
      id: "total403Errors",   
      label: "403",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "total404Errors",   
      label: "404",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "total422Errors",   
      label: "422",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "total5XXErrors",   
      label: "5XX",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "totalErrors",      
      label: "Errors",
      sortOrder: SORTORDER.ASC 
    },
    { 
      id: "errorPercentage",  
      label: "Errors (%)",
      sortOrder: SORTORDER.ASC 
    },
    // { 
    //   id: "uptime",           
    //   label: "Successful Requests (%)",
    //   sortOrder: SORTORDER.ASC 
    // }
  ];

  const downTimeTypes = ["SCHEDULED_MAINTENANCE", "THIRD_PARTY", "OTHERS"]

export { Headings, SORTORDER, downTimeTypes }